<div class="scrollable" [style.height]="scrollHeightSignal() + 'px'" (scroll)="appService.closeAllTooltips()">
  <div class="w-100 ltr flex flex-col pb-2.5">
    <app-options-button
      [settings]="settings"
      settingOption="skipFitToPage"
      selectorType="check"
      (optionSelect)="settingOptionSelected($event)"
    >
    </app-options-button>
    <hr />
    @if (printProduct) {
      <div class="qtyCounter flex flex-row items-stretch justify-between">
        <div class="flex flex-row items-center justify-start gap-1.5">
          <span class="title">Copias de esta carpeta: </span>
          <input
            type="text"
            [value]="printProduct.qty"
            (input)="writeQty($event)"
            (keydown)="writeQty($event)"
            step="1"
            min="1"
            class="number"
          />
        </div>
        <app-qty-stepper
          [qty]="printProduct.qty"
          [isGeneralSettings]="true"
          (changes)="changeQty($event)"
          [styleType]="'configurator'"
          [min]="1"
          [max]="9999"
        >
        </app-qty-stepper>
      </div>
    }
    <hr />
    <app-options-button [settings]="settings" settingOption="color" (optionSelect)="settingOptionSelected($event)">
    </app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="pageSize"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="paperWeight"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="twoSided"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="pageOrientation"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="pagesPerSheet"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <hr />
    <app-options-button
      [settings]="settings"
      settingOption="pageTurn"
      (optionSelect)="settingOptionSelected($event)"
    ></app-options-button>
    <!-- HUECO -->
  </div>
</div>

<div
  *ngIf="!appService.isMobile()"
  class="fixed-footer"
  (elementResize)="fixedFooterDesktopHeight.set($event)"
  #fixedFooterDesktop
>
  <ion-button class="goToGeneralButton" (click)="goToFinishing()">
    <div class="button-content">
      <span class="span-content">Configura el acabado</span>
    </div>
    <ion-icon src="assets/icon/arrow-right.svg" class="arrow-icon"></ion-icon>
  </ion-button>
</div>

<div
  *ngIf="appService.isMobile()"
  class="floatting flex flex-col"
  (elementResize)="fixedFooterMobileHeight.set($event)"
  #fixedFooterMobile
>
  <ion-button class="goToFinishingButton w-100" (click)="goToFinishing()">
    Configura el acabado de esta carpeta
    <ion-icon src="assets/icon/arrow-right.svg"></ion-icon>
  </ion-button>
  <ion-button color="tertiary" class="goToFinishingButton w-100" (click)="closeSettings()">
    Confirmar ajustes
    <ion-icon src="assets/icon/arrow-right.svg"></ion-icon>
  </ion-button>
</div>
